import { z } from 'zod'

import { AiAutomationSchemas } from 'shared/api/requests/aiAutomation/schemas'

const tovReactionSchema = z
  .object({
    is_reaction_positive: z.boolean(),
    user_reaction: z.string().nullable(),
  })
  .extend(AiAutomationSchemas.tovSample.shape)

export const AiToneOfVoiceSchemas = {
  startSetup: {
    request: z.undefined(),
    response: z.undefined(),
    query: z.undefined(),
    path: z.undefined(),
  },
  saveReaction: {
    request: z.object({
      replies_with_feedback: z.array(tovReactionSchema),
    }),
    response: z.undefined(),
    query: z.undefined(),
    path: z.undefined(),
  },
}

export type TovReaction = z.infer<typeof tovReactionSchema>
